import { ComponentModalConfig, ModalSize } from 'ngx-fomantic-ui';
import { ICreateDirectoryModalContext, IListItemQueryResult } from '../../models/interface';
import { CreateDirectoryModalComponent } from './create-directory-modal.component';
export class CreateDirectoryModal extends ComponentModalConfig<ICreateDirectoryModalContext, IListItemQueryResult, void> {
    constructor(context: ICreateDirectoryModalContext) {
        super(CreateDirectoryModalComponent, context);
        this.isClosable = true;
        this.transitionDuration = 200;
        this.size = ModalSize.Tiny;
    }
}
